import { reportBoundaryError } from '@hub/app/bootstrap/reportBoundaryError';
import { DevErrorDetails } from '@hub/components/DevErrorDetails';
import { ErrorEventCode } from '@hub/components/ErrorEventCode';
import { HelpLinkButton } from '@hub/components/HelpLinkButton';
import { m } from '@hub/messages';
import { Button, ErrorPage, ErrorPageActions, ErrorPageMessage, ErrorPageTitle } from '@platform/ui';
import type { ErrorComponentProps } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { useGoBackOrHome } from '../hooks/useGoBackOrHome';

export function DefaultErrorComponent({ error, info }: ErrorComponentProps) {
  const goBackOrHome = useGoBackOrHome();
  const [eventId, setEventId] = useState('');

  useEffect(() => {
    const id = reportBoundaryError(error, 'router', info?.componentStack);
    setEventId(id);
  }, [error, info?.componentStack]);

  return (
    <ErrorPage>
      <ErrorPageTitle>{m.commons_error_page_title()}</ErrorPageTitle>
      <ErrorPageMessage>{m.commons_error_page_message_generic()}</ErrorPageMessage>
      <ErrorEventCode eventId={eventId} />
      <DevErrorDetails error={error} componentStack={info?.componentStack} />
      <ErrorPageActions>
        <Button size="lg" onClick={goBackOrHome}>
          {m.commons_error_page_back_to_home()}
        </Button>
        <HelpLinkButton />
      </ErrorPageActions>
    </ErrorPage>
  );
}
